import { useOAuth2Context } from "./contexts/OAuth2Context";
import { ConfigurationParameters, Configuration as ApiConfiguration } from "./data";


const useApiConfiguration = () => {
    const { userManager } = useOAuth2Context();

    const configParams: ConfigurationParameters = {
        basePath: process.env.REACT_APP_API_URL,
        accessToken: async (name) => {
            const user = await userManager.getUser();

            if (!user)
                throw new Error("Utente non autenticato");

            if (user.expired) {
                const refreshUser = await userManager.signinSilent();

                if (!refreshUser)
                    throw new Error('Sessione scaduta');

                return `Bearer ${refreshUser.access_token}`;
            }

            const currentToken = user.access_token;
            return "Bearer " + currentToken;
        }
    };

    return new ApiConfiguration(configParams);
}

export default useApiConfiguration;